import React from 'react';

const OrderSourceSelector = props => {
    // const getSourceType = (deviceType) => {

    switch (props.source) {
        case 'WEB_IOS':
            return (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {/* <img src={WebIcon} style={{ width: 26, height: 26 }} />
                    <img src={AppIosIcon} style={{ width: 26, height: 26 }} /> */}
                    Web iOS
                </div>
            );
        case 'WEB_ANDROID':
            return (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {/* <img src={WebIcon} style={{ width: 26, height: 26 }} />
                    <img src={AppAndroidIcon} style={{ width: 26, height: 26 }} /> */}
                    Web Android
                </div>
            );
        case 'WEB':
            // return <img src={WebIcon} style={{ width: 26, height: 26 }} />;
            return 'Desktop';
        case 'APP_ANDROID':
            // return <img src={AppAndroidIcon} style={{ width: 26, height: 26 }} />;
            return 'App Android';
        case 'APP_IOS':
            // return <img src={AppIosIcon} style={{ width: 26, height: 26 }} />;
            return 'App iOS';
        default:
            return 'N/A';
    }
    // }
}

export default OrderSourceSelector;


// WEBPACK FOOTER //
// ./src/components/common/OrderSourceSelector.js